// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n*.bold-text[data-v-2e7b430e] {\r\n  font-weight: bold;\n}\n*.btn-outline-danger[data-v-2e7b430e] {\r\n  border: 2px solid;\n}\r\n", ""]);
// Exports
module.exports = exports;
